// Единый источник правды по маршрутам — используется и на клиенте (main.jsx),
// и на сервере при пререндере (entry-server.jsx), и в списке для prerender.mjs.
// Новый маршрут добавляется ТОЛЬКО здесь — рассинхрон клиент/сервер исключён.
import Home from './pages/Home';
import ProjectDetail from './pages/ProjectDetail';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Cookie from './pages/Cookie';
import ThankYou from './pages/ThankYou';

export const routes = [
  { path: '/', element: <Home /> },
  { path: '/project/:id', element: <ProjectDetail /> },
  { path: '/impressum', element: <Impressum /> },
  { path: '/datenschutz', element: <Datenschutz /> },
  { path: '/cookie-richtlinien', element: <Cookie /> },
  { path: '/danke', element: <ThankYou /> },
];

// Конкретные URL, которые нужно отрендерить в статический HTML при сборке.
// Динамический /project/:id разворачивается в реальные id (они захардкожены в данных).
export const prerenderUrls = [
  '/',
  '/project/mittelring-13',
  '/impressum',
  '/datenschutz',
  '/cookie-richtlinien',
  '/danke',
];
